const head = '<img src="https://testimages.ksbao.com/tk_img/';
const config = "https://testimages.ksbao.com/tk_img/";
// 题型图片单独处理
export function procImg(string, _appEName) {
  //   Title AppEname
  // console.log(string);
  if (!string) {
    return;
  }
  if (string.indexOf("[Img") == "-1") {
    return string;
  } else {
    var result = "";
    if (string.replace(/\s+/g, "") != "") {
      //区别内网和外网地址 xjy 20170920
      var foot = '"/>';
      result = string.replace(/\[ImgDir([^\]]*)\]/g, function(word) {
        //图片地址 必须是[OH[ImgDir_SJXL_YJFCDSB/~-.gif]]  [ImgDir开头
        word = word.replace(/\+/, "%2B");
        var len = word.length;
        return head + word.substring(1, len - 1) + foot;
      });
    }
    // console.log(result,'------------->>');
    return result;
  }
}
export function styleData(str, Answer) {
  if (str === "ATEST") {
    return "A型题";
  } else if (str === "XTEST") {
    return "X型题";
  } else if (str === "TKTEST") {
    return "填空题";
  } else if (str === "PDTEST") {
    return "判断题";
  } else if (str === "JDTEST") {
    return "简答题";
  } else if (str === "A3TEST") {
    if (Answer.indexOf("[") == "-1") {
      if (Answer.length == 1) {
        return "共用题干单选题";
      } else {
        return "共用题干不定项选择题";
      }
    } else {
      Answer = Answer.replace("[", "");
      Answer = Answer.replace("]", "");
      if (Answer.length == 1) {
        return "共用题干单选题";
      } else {
        return "共用题干不定项选择题";
      }
    }
  } else if (str === "BTEST") {
    if (Answer.indexOf("[") == "-1") {
      if (Answer.length == 1) {
        return "配伍单选题";
      } else {
        return "配伍选择题";
      }
    } else {
      // const newAnswer = JSON.parse(Answer);
      // console.log(newAnswer,'Wca');
      Answer = Answer.replace("[", "");
      Answer = Answer.replace("]", "");
      if (Answer.length == 1) {
        return "配伍单选题";
      } else {
        return "配伍选择题";
      }
    }
  }
}

// 练习数据处理
export function practiceWithData(arr) {
  let newData = JSON.parse(JSON.stringify(arr));
  let answerArr = [];
  console.log(newData);
  newData.StyleItems.forEach(item => {
    item.TestItems.forEach(zitem => {
      if (zitem.TestType == "A3TEST") {
        zitem.A3TestItems?.forEach(vitem => {
          vitem.TestID = zitem.TestID;
          vitem.Style = styleData(vitem.TestType, vitem.Answer);
          if (vitem.Answer.indexOf("[") !== "-1") {
            vitem.Answer = vitem.Answer.replace("[", "");
            vitem.Answer = vitem.Answer.replace("]", "");
          }
          vitem.Score = item.Score; // 该小题分值
          vitem.Title = procImg(vitem.Title, zitem.AppEname); // 题型图片处理
          vitem.UserAnswer = null; // 用户自己填写的答案
          vitem.AppEname = zitem.AppEname;
          vitem.PaperTestID = zitem.PaperTestID;
          vitem.ChildID = zitem.ChildID;
          vitem.AppID = zitem.AppID;
          vitem.ChapterID = zitem.ChapterID;
          vitem.StyleID = zitem.StyleID;
          vitem.SourceTestID = zitem.SourceTestID;
          vitem.FrontTitle = zitem.FrontTitle;
          vitem.Type = vitem.TestType; // 题型类型
          vitem.xState = false; // 练习多选题未提交控制解析是否弹出
          vitem.colourState = false; // 练习颜色方法是否调用
          vitem.SelectedItems?.forEach(sitem => {
            sitem.Content = procImg(sitem.Content, zitem.AppEname); // 选项图片处理
          });
          answerArr.push(vitem);
        });
      } else if (zitem.TestType == "BTEST") {
        zitem.BTestItems.forEach(vitem => {
          vitem.TestID = zitem.TestID;
          vitem.Style = styleData(vitem.TestType, vitem.Answer);
          if (vitem.Answer.indexOf("[") !== "-1") {
            vitem.Answer = vitem.Answer.replace("[", "");
            vitem.Answer = vitem.Answer.replace("]", "");
          }
          vitem.Score = item.Score; // 该小题分值
          vitem.Title = procImg(vitem.Title, zitem.AppEname); // 题型图片处理
          vitem.UserAnswer = null; // 用户自己填写的答案
          vitem.SourceTestID = zitem.SourceTestID;
          vitem.AppEname = zitem.AppEname;
          vitem.SelectedItems = zitem.SelectedItems; // 答案
          vitem.Type = vitem.TestType; // 题型类型
          vitem.PaperTestID = zitem.PaperTestID;
          vitem.ChildID = zitem.ChildID;
          vitem.AppID = zitem.AppID;
          vitem.ChapterID = zitem.ChapterID;
          vitem.StyleID = zitem.StyleID;
          vitem.xState = false; // 练习多选题未提交控制解析是否弹出
          vitem.colourState = false; // 练习颜色方法是否调用
          vitem.SelectedItems?.forEach(sitem => {
            sitem.Content = procImg(sitem.Content, zitem.AppEname); // 选项图片处理
          });
          answerArr.push(vitem);
        });
      } else {
        // item.TestItems.forEach((zitem, index) => {
        zitem.Type = zitem.TestType;
        zitem.Style = styleData(zitem.TestType, zitem.Answer);
        zitem.Score = item.Score; // 该小题分值
        zitem.Title = procImg(zitem.Title, zitem.AppEname); // 题型图片处理
        zitem.SelectedItems?.forEach(sitem => {
          sitem.Content = procImg(sitem.Content, zitem.AppEname); // 选项图片处理
        });
        zitem.colourState = false; // 练习颜色方法是否调用
        zitem.UserAnswer = null; // 用户自己填写的答案
        zitem.submitState = false; // 简答题这些是否提交
        answerArr.push(zitem);
        // });
      }
    });
  });
  return answerArr;
}
// 题型数据处理
export function todealWithData(arr) {
  let newData = JSON.parse(JSON.stringify(arr));
  let answerArr = [];
  // let newList = []; // 把所有的题全部汇总起来渲染
  newData.StyleItems.forEach(item => {
    // console.log(item.Type);
    if (item.Type == "A3TEST") {
      // 共选题干题目数据单独处理
      item.TestItems.forEach(zitem => {
        zitem.A3TestItems?.forEach(vitem => {
          vitem.TestID = zitem.TestID;
          vitem.Style = item.Style;
          vitem.Score = item.Score; // 该小题分值
          vitem.Title = procImg(vitem.Title, zitem.AppEname); // 题型图片处理
          vitem.UserAnswer = null; // 用户自己填写的答案
          vitem.AppEname = zitem.AppEname;
          vitem.PaperTestID = zitem.PaperTestID;
          vitem.ChildID = zitem.ChildID;
          vitem.AppID = zitem.AppID;
          vitem.ChapterID = zitem.ChapterID;
          vitem.StyleID = zitem.StyleID;
          vitem.SourceTestID = zitem.SourceTestID;
          vitem.FrontTitle = zitem.FrontTitle;
          vitem.Type = item.Type; // 题型类型
          vitem.xState = false; // 练习多选题未提交控制解析是否弹出
          vitem.colourState = false; // 练习颜色方法是否调用
          vitem.SelectedItems?.forEach(sitem => {
            sitem.Content = procImg(sitem.Content, zitem.AppEname); // 选项图片处理
          });
          answerArr.push(vitem);
        });
      });
    } else if (item.Type == "BTEST") {
      // 共用选项题单独处理 B型题 C型题
      item.TestItems.forEach(zitem => {
        zitem.BTestItems.forEach(vitem => {
          vitem.TestID = zitem.TestID;
          vitem.Style = item.Style;
          vitem.Score = item.Score; // 该小题分值
          vitem.Title = procImg(vitem.Title, zitem.AppEname); // 题型图片处理
          vitem.UserAnswer = null; // 用户自己填写的答案
          vitem.SourceTestID = zitem.SourceTestID;
          vitem.AppEname = zitem.AppEname;
          vitem.SelectedItems = zitem.SelectedItems; // 答案
          vitem.Type = item.Type; // 题型类型
          vitem.PaperTestID = zitem.PaperTestID;
          vitem.ChildID = zitem.ChildID;
          vitem.AppID = zitem.AppID;
          vitem.ChapterID = zitem.ChapterID;
          vitem.StyleID = zitem.StyleID;
          vitem.xState = false; // 练习多选题未提交控制解析是否弹出
          vitem.colourState = false; // 练习颜色方法是否调用
          vitem.SelectedItems?.forEach(sitem => {
            sitem.Content = procImg(sitem.Content, zitem.AppEname); // 选项图片处理
          });
          answerArr.push(vitem);
        });
      });
    } else {
      item.TestItems.forEach((zitem, index) => {
        zitem.Type = item.Type;
        zitem.Style = item.Style;
        zitem.Score = item.Score; // 该小题分值
        zitem.Title = procImg(zitem.Title, zitem.AppEname); // 题型图片处理
        zitem.SelectedItems?.forEach(sitem => {
          sitem.Content = procImg(sitem.Content, zitem.AppEname); // 选项图片处理
        });
        zitem.colourState = false; // 练习颜色方法是否调用
        zitem.UserAnswer = null; // 用户自己填写的答案
        zitem.submitState = false; // 简答题这些是否提交
        answerArr.push(zitem);
      });
    }
  });
  // console.log(answerArr, "新数组");
  return answerArr;
}
// 难易度数据处理
export function facilityHandleata(arr) {
  let newData = JSON.parse(JSON.stringify(arr));
  let answerArr = [];
  newData.StyleItems.forEach(item => {
    if (item.Type == "A3TEST") {
      item.TestItems.forEach(zitem => {
        zitem.TestJSON = JSON.parse(zitem.TestJSON);
        zitem.A3TestItem = []; // A3题型数组
        const obj = {
          A3TestItemID: zitem.TestJSON.AllTestID,
          Title: facilityProcImg(zitem.TestJSON.Title, zitem.AppEname),
          Explain: zitem.TestJSON.Explain,
          TestPoint: zitem.TestJSON.TestPoint,
          SelectedItems: zitem.TestJSON.SelectedItems?.map(sitem => {
            sitem.Content = facilityProcImg(sitem.Content, zitem.AppEname);
            return sitem;
          }),
          Answer: zitem.TestJSON.Answer,
          TestID: zitem.TestID,
          Style: zitem.TestJSON.Style,
          Score: zitem.TestJSON.Score,
          UserAnswer: null,
          AppEname: zitem.AppEname,
          FrontTitle: facilityProcImg(
            zitem.TestJSON.FrontTitle,
            zitem.AppEname
          ),
          Type: item.Type
        };
        zitem.A3TestItem.push(obj);
        zitem.A3TestItem.forEach(qitem => {
          answerArr.push(qitem);
        });
      });
    } else if (item.Type == "BTEST") {
      item.TestItems.forEach(zitem => {
        zitem.TestJSON = JSON.parse(zitem.TestJSON);
        zitem.BTestItem = []; // B题型数组
        const obj = {
          TestID: zitem.TestID,
          Score: zitem.TestJSON.Score,
          Style: zitem.TestJSON.Style,
          Title: facilityProcImg(zitem.TestJSON.Title, zitem.AppEname),
          UserAnswer: null,
          AppEname: zitem.AppEname,
          SelectedItems: zitem.TestJSON.SelectedItems?.map(sitem => {
            sitem.Content = facilityProcImg(sitem.Content, zitem.AppEname);
            return sitem;
          }),
          Type: item.Type,
          BTestItemID: zitem.TestJSON.AllTestID,
          FrontTitle: facilityProcImg(
            zitem.TestJSON.FrontTitle,
            zitem.AppEname
          ),
          Explain: zitem.TestJSON.Explain,
          TestPoint: zitem.TestJSON.TestPoint,
          Answer: zitem.TestJSON.Answer
        };
        zitem.BTestItem.push(obj);
        zitem.BTestItem.forEach(qitem => {
          answerArr.push(qitem);
        });
      });
    } else {
      item.TestItems.forEach(zitem => {
        try {
          zitem.TestJSON = JSON.parse(zitem.TestJSON);
          console.log(zitem);
          zitem.TestJSON.Title = facilityProcImg(
            zitem.TestJSON.Title,
            zitem.AppEname
          );
          zitem.TestJSON.FrontTitle = facilityProcImg(
            zitem.TestJSON.FrontTitle,
            zitem.AppEname
          );
          // console.log(zitem.TestJSON.SelectedItems, "??", zitem);
          if (zitem.TestJSON.SelectedItems) {
            zitem.TestJSON.SelectedItems.forEach(sitem => {
              sitem.Content = facilityProcImg(sitem.Content, zitem.AppEname); // 选项图片处理
            });
          }
          zitem.TestJSON.AppEname = zitem.AppEname;
          zitem.TestJSON.UserAnswer = null; // 用户自己填写的答案
          // if (item.TestID == 315134707) {
          //   console.log(zitem, "zitem", zitem.AppEname);
          // }
          answerArr.push(objFun(zitem));
        } catch (error) {
          console.log("看看错误的", error, zitem);
          if (String(error).includes("／")) {
            return;
          }
          // zitem.TestJSON = JSON.parse(zitem.TestJSON.replace(/[‘]|[""]/g, '"'));
        }
        // console.log(zitem,'---------------->');

        // answerArr.push(zitem);
        zitem = objFun(zitem);
      });
    }
  });
  console.log(answerArr);
  return answerArr;
}
function objFun(obj) {
  var res = {}; //定义一个对象，用来存储结果
  function isObj(obj) {
    //定义一个函数，用来对obj进行遍历
    for (var key in obj) {
      if (Object.prototype.toString.call(obj[key]) == "[object Object]") {
        //如果值为对象，则进行递归
        isObj(obj[key]);
      } else {
        //不为对象则将值添加给res
        res[key] = obj[key];
      }
    }
  }
  isObj(obj); //调用函数
  return res; //返回结果
}

// 难易度组卷章节数据处理
export function facilityGetCptData(data) {
  // 后端稀烂，ID都给重复的
  data.forEach(item => {
    item.TestCount = item.TestNum;
    item.ID = item.ID + item.NodeType;
    if (item.Childs) {
      item.Childs.forEach(zitem => {
        zitem.TestCount = zitem.TestNum;
        zitem.ID = zitem.ID + zitem.NodeType;
        if (zitem.Childs) {
          zitem.Childs.forEach(sitem => {
            sitem.TestCount = sitem.TestNum;
            // sitem.ID = sitem.ID + sitem.NodeType;
            if (sitem.Childs) {
              sitem.Childs.forEach(citem => {
                citem.TestCount = citem.TestNum;
              });
            }
          });
        }
      });
    }
  });
  // console.log(data, "wwww");
  return data;
}
// 难易度题型处理A3和B型题
export function specialTreeatment(data) {
  data.forEach(item => {
    try {
      // item.ID = item.AllTestID
      item.TestID = item.AllTestID; // AllTestID
      item.TestJson = JSON.parse(item.TestJson);
      item.TestJson.TestType = item.TestJson.Type;
      item.TestJson.ID = item.TestJson.AllTestID;
      item.TestJson.appEName = item.appEName;
      item.Type = item.TestJson.Type;
      item.StyleName = item.TestJson.Style;
      item.TestJson.MainTitle = facilityProcImg(
        item.TestJson.FrontTitle,
        item.appEName
      );
      item.TestJson.Title = facilityProcImg(item.TestJson.Title, item.appEName);
      if (item.TestJson.SelectedItems instanceof Array == true) {
        item.TestJson.SelectedItem = item.TestJson.SelectedItems.map(zitem => {
          return facilityProcImg(zitem.Content, item.appEName);
        });
      }
      if (item.TestJson.Answer == undefined) {
        item.TestJson.Answer = ""; //给一个Answer为空的处理。
      }
      // 此处A3和B题型不是树结构需合并
      const obj = {
        ID: item.TestJson.ChildTableID,
        Title: item.TestJson.Title,
        Explain: item.TestJson.Explain,
        TestPoint: item.TestJson.TestPoint,
        SelectedItem: item.TestJson.SelectedItems.map(citem => {
          return citem.Content;
        }),
        Answer: [item.TestJson.Answer]
      };

      //

      if (item.TestJson.Type === "A3TEST") {
        item.TestJson.A3TestItem = []; // A3题型数组
        // console.log(filterRepeatID(data,item.AllTestID,item.ChildTableID),'??22');
        // item.TestJson.A3TestItem.push(filterRepeatID(data,item.AllTestID,item.ChildTableID));
      } else if (item.TestJson.Type === "BTEST") {
        item.TestJson.BTestItem = []; // B题型数组
        // item.TestJson.BTestItem.push(filterRepeatID(data,item.AllTestID,item.ChildTableID));
      }
    } catch (error) {
      if (String(error).includes("／")) {
        return;
      }
      item.TestJson = JSON.parse(item.TestJson.replace(/[‘]|[""]/g, '"'));
    }
  });
  const list2 = data.reduce((p, item) => {
    let i = -1;
    if (item.Type == "BTEST") {
      if (p.length) i = p.findIndex(f => f.AllTestID == item.AllTestID);
      if (i > -1) {
        p[i].TestJson.BTestItem.push({
          ID: item.TestJson.ChildTableID,
          Title: item.TestJson.Title,
          Explain: item.TestJson.Explain,
          TestPoint: item.TestJson.TestPoint,
          SelectedItem: item.TestJson.SelectedItems.map(citem => {
            return citem.Content;
          }),
          Answer: [item.TestJson.Answer]
        });
      } else {
        p.push({
          ...item,
          TestJson: {
            ...item.TestJson,
            BTestItem: [
              {
                ID: item.TestJson.ChildTableID,
                Title: item.TestJson.Title,
                Explain: item.TestJson.Explain,
                TestPoint: item.TestJson.TestPoint,
                SelectedItem: item.TestJson.SelectedItems.map(citem => {
                  return citem.Content;
                }),
                Answer: [item.TestJson.Answer]
              }
            ]
          }
        });
      }
    } else if (item.Type === "A3TEST") {
      if (p.length) i = p.findIndex(f => f.AllTestID == item.AllTestID);
      if (i > -1) {
        p[i].TestJson.A3TestItem.push({
          ID: item.TestJson.ChildTableID,
          Title: item.TestJson.Title,
          Explain: item.TestJson.Explain,
          TestPoint: item.TestJson.TestPoint,
          SelectedItem: item.TestJson.SelectedItems.map(citem => {
            return citem.Content;
          }),
          Answer: [item.TestJson.Answer]
        });
      } else {
        p.push({
          ...item,
          TestJson: {
            ...item.TestJson,
            A3TestItem: [
              {
                ID: item.TestJson.ChildTableID,
                Title: item.TestJson.Title,
                Explain: item.TestJson.Explain,
                TestPoint: item.TestJson.TestPoint,
                SelectedItem: item.TestJson.SelectedItems.map(citem => {
                  return citem.Content;
                }),
                Answer: [item.TestJson.Answer]
              }
            ]
          }
        });
      }
    } else {
      p.push(item);
    }

    return p;
  }, []);
  console.log(list2);
  return list2;
}

// 单包题库图片处理
export function facilityProcImg(htmlTxt, _appEName) {
  //https://testimages.ksbao.com/tk_img/TitleImage_B/%E6%8D%9F.png
  var indexArr = []; //id索引数组
  var curIndex = 0; //当前试题索引
  var newHtml = ""; //替换后的html
  // console.log(htmlTxt,'htmlTxt');

  // var _appEName = sessionStorage.getItem("ImgAppEName") || getQueryString('appEName') || localStorage.getItem("appEName")
  if (!htmlTxt) {
    return htmlTxt;
  }
  while (htmlTxt.length > curIndex && htmlTxt.indexOf("[", curIndex) > -1) {
    //处理找到的<img>标签
    var imgIndex = htmlTxt.indexOf("[", curIndex);
    indexArr.push(imgIndex);
    curIndex = imgIndex + 1;
  }
  if (indexArr.length === 0) {
    return htmlTxt;
  }

  var newIndexArr = [];
  //循环处理[]里的内容，剔除不规范的[]，比如[ddd[ggg[ee.gif]]]
  for (var i = 0; i < indexArr.length; i++) {
    var startIndex = indexArr[i];
    var endIndex = htmlTxt.indexOf("]", startIndex);
    if (
      endIndex > -1 &&
      ((i !== indexArr.length - 1 && indexArr[i + 1] > endIndex) ||
        (i === indexArr.length - 1 && indexArr[i] < endIndex))
    ) {
      var picName = htmlTxt.substring(startIndex + 1, endIndex);
      if (
        picName.indexOf(".gif") >= 0 ||
        picName.indexOf(".GIF") >= 0 ||
        picName.indexOf(".jpg") >= 0 ||
        picName.indexOf(".JPG") >= 0 ||
        picName.indexOf(".png") >= 0 ||
        picName.indexOf(".PNG") >= 0
      ) {
        newIndexArr.push([startIndex, endIndex + 1]);
      }
    }
  }
  if (newIndexArr.length === 0) {
    return htmlTxt;
  }

  //添加网址前缀
  for (var j = 0; j < newIndexArr.length; j++) {
    if (j === 0) {
      newHtml = htmlTxt.substring(0, newIndexArr[j][0]);
      newHtml += _replaceImgSrc(
        htmlTxt.substring(newIndexArr[j][0], newIndexArr[j][1])
      );
      //只有一个则加上尾部
      if (newIndexArr.length === 1) {
        newHtml += htmlTxt.substring(newIndexArr[j][1], htmlTxt.length);
      }
    } else if (j === newIndexArr.length - 1) {
      newHtml += htmlTxt.substring(newIndexArr[j - 1][1], newIndexArr[j][0]);
      newHtml += _replaceImgSrc(
        htmlTxt.substring(newIndexArr[j][0], newIndexArr[j][1])
      );
      newHtml += htmlTxt.substring(newIndexArr[j][1], htmlTxt.length);
    } else {
      newHtml += htmlTxt.substring(newIndexArr[j - 1][1], newIndexArr[j][0]);
      newHtml += _replaceImgSrc(
        htmlTxt.substring(newIndexArr[j][0], newIndexArr[j][1])
      );
    }
  }
  return newHtml
    .replace(new RegExp("\r", "gm"), "<br/>")
    .replace(new RegExp("\n", "gm"), "<br/>");

  //[sdfsdf.gif]
  function _replaceImgSrc(str) {
    var picSrcStr,
      setModeImg = "TitleImage_B";
    if (str.split("_ei_").length > 1) {
      // if (G_Prg.getCookie('NIGHTMODE') === 'night') {//夜间模式
      //   setModeImg = 'TitleImage_W';
      // }
      picSrcStr =
        config +
        setModeImg +
        "/" +
        encodeURIComponent(
          str.replace("_ei_", "").substr(1, str.replace("_ei_", "").length - 2)
        );
      picSrcStr = picSrcStr.replace(/#/g, "%23");
      var widthImg = "";
      // const setting = localStorage.getItem('setting' + userID) ? JSON.parse(localStorage.getItem('setting' + userID)) : {}
      // // var _fontSize = setting.testFontSize ? setting.testFontSize + 'px' : '16px'
      // var _fontSize = setting.fontSize ? setting.fontSize + 'px' : '16px'
      // var _fontSize =  '18px'
      switch (_fontSize) {
        case "14px":
          _fontSize = "13px";
          break;
        case "23px":
          _fontSize = "24px";
          break;
        case "26px":
          _fontSize = "28px";
          break;
        default:
          break;
      }
      widthImg = "width='" + (Number(_fontSize.split("px")[0]) + 2) + "'";
      return (
        "<img newModel='n' style='max-width:100%;height:auto;vertical-align:sub;' " +
        widthImg +
        " src='" +
        picSrcStr +
        "'/>"
      );
    }

    picSrcStr =
      config +
      "ImgDir_" +
      _appEName +
      "/" +
      encodeURIComponent(str.substr(1, str.length - 2));
    picSrcStr = picSrcStr.replace(/#/g, "%23");
    return (
      "<img style='vertical-align:sub; max-width:100%'height:auto; src='" +
      picSrcStr +
      "'/>"
    );
  }
}

// 判断是什么类型组卷
export function typeTestPaper(PaperMode) {
  const obj = {};
  if (PaperMode === "unified_db") {
    obj.PaperModeName = "统一命题";
    obj.PaperModeExam = "智能组卷";
  } else if (PaperMode === "random_db") {
    obj.PaperModeName = "随机命题";
    obj.PaperModeExam = "智能组卷";
  } else if (PaperMode === "unified_exam") {
    obj.PaperModeName = "统一命题";
    obj.PaperModeExam = "试卷组卷";
  } else if (PaperMode === "random_exam") {
    obj.PaperModeName = "随机命题";
    obj.PaperModeExam = "试卷组卷";
  } else if (PaperMode === "unified_Proportion") {
    obj.PaperModeName = "统一命题";
    obj.PaperModeExam = "权重组卷";
  } else if (PaperMode === "random_Proportion") {
    obj.PaperModeName = "随机命题";
    obj.PaperModeExam = "权重组卷";
  } else if (PaperMode === "sg_db") {
    obj.PaperModeName = "手动命题";
    obj.PaperModeExam = "精准组卷";
  } else if (PaperMode === "paper") {
    obj.PaperModeExam = "纸质试卷";
  } else if (PaperMode === "unified_difflever") {
    obj.PaperModeExam = "难易度组卷";
    obj.PaperModeName = "统一命题";
  } else if (PaperMode === "random_difflever") {
    obj.PaperModeExam = "难易度组卷";
    obj.PaperModeName = "随机命题";
  }
  return obj;
}
